import { render, staticRenderFns } from "./InviraUserList.vue?vue&type=template&id=33895652&scoped=true"
import script from "./InviraUserList.vue?vue&type=script&lang=js"
export * from "./InviraUserList.vue?vue&type=script&lang=js"
import style0 from "./InviraUserList.vue?vue&type=style&index=0&id=33895652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33895652",
  null
  
)

export default component.exports